// extracted by mini-css-extract-plugin
export default {"activeSidebar":"Ra-z","pageLayout":"Sa-z","mainContent":"Ta-z","columnLayout":"Ua-z","columnLayoutFill":"Va-z","columnLayoutLast":"Wa-z"};